import {definePreset} from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const PrimaryPalette = definePreset(Aura, {
  semantic: {
    primary: {
      50:  '#e8f7fd',
      100: '#d1f0fb',
      200: '#a3e1f8',
      300: '#75d2f5',
      400: '#47c4f2',
      500: '#26ace4',
      600: '#1e8aba',
      700: '#166890',
      800: '#0e4666',
      900: '#06243c'
    }
  }
});
